import React, { useReducer } from 'react';
import { PolicyContextReducer } from './reducer/PolicyContextReducer';
import { PolicyContext } from './PolicyContext';
import { PolicyDispatchContext } from './PolicyDispatchContext';
import { IPolicyContextState } from './state/IPolicyContextState';
import { IOrderDetailsData } from '../../ui-toolkit/orders/interfaces/IOrderDetailsData';

interface IApplicationProviderProps {
  order: IOrderDetailsData;
  children: React.ReactNode;
}

// This is a standard React Context Provider, not a MobX Provider.
// Its implementation may be incomplete.
// In effect, we may have two sources of truth.
export const PolicyContextProvider: React.FC<IApplicationProviderProps> = ({ children, order }) => {
  const [state, dispatch] = useReducer(PolicyContextReducer, { order } as IPolicyContextState);

  return (
    <PolicyDispatchContext.Provider value={dispatch}>
      <PolicyContext.Provider value={state}>{children}</PolicyContext.Provider>
    </PolicyDispatchContext.Provider>
  );
};
